(function () {
  const loader = document.currentScript;
  const review = new URLSearchParams(location.search).get('review');
  const design = review === 'design' || (review !== 'commerce' && loader.dataset.defaultMode !== 'commerce');
  if (!location.hash && loader.dataset.initialRoute) location.hash = loader.dataset.initialRoute;
  document.documentElement.dataset.ssMode = design ? 'design' : 'commerce';
  const market = document.querySelector('.ss-market');
  if (market) {
    if (design) market.remove();
    else market.hidden = false;
  }
  if (design) {
    document.querySelector('.draft').hidden = false;
    document.querySelector('.draft').innerHTML = 'DESIGN PREVIEW · No orders, payments or submissions <a href="#preview-notes">Review changes</a>';
    document.querySelector('.cart-link').setAttribute('aria-label', 'Open preview shopping bag');
    document.querySelector('.footline > span:last-child').textContent = 'Design prices shown for review.';
    document.querySelector('[data-contact-link]').setAttribute('href', '#contact');
    document.querySelector('a[href="https://sevenstorys.com/account"]')?.remove();
  }
  const script = document.createElement('script');
  script.src = design ? loader.dataset.designSrc : loader.dataset.commerceSrc;
  script.async = false;
  script.onerror = () => {
    document.querySelector('#view').textContent = 'The preview could not load. Please refresh this page.';
  };
  document.body.appendChild(script);
}());
